import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import QuestionForm from '../../../components/forms/QuestionForm';
import { useQuestionApi } from '../../../hooks/useQuestionApi';
import { useNavigate, useParams } from 'react-router-dom';
import { QuestionDTO } from '../../../services/apiClient';

const QuestionEdit: React.FC = () => {
  const { getById, edit, isLoading } = useQuestionApi();
  const [entityData, setEntityData] = useState<QuestionDTO | null>(null);
  const { questionSetId, questionId } = useParams<{ questionSetId: string, questionId:string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: `Question Set`, href: `/admin/questionsets/${questionSetId}` },
    { label: `Questions`, href: `/admin/questionsets/${questionSetId}/questions` },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(questionId!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Question data:', error);
      }
    };

    fetchEntityData();
  }, [questionId]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(questionId!, data);
      navigate(`/admin/questionsets/${questionSetId}`);
    } catch (error) {
      console.error('Error updating Question:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/questionsets"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Content.Question.Edit'
    >
        {entityData ? (
          <QuestionForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate(`/admin/questionsets/${questionSetId}`)}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default QuestionEdit;